import { render, staticRenderFns } from "./wax-usage-table.vue?vue&type=template&id=2cf62dd0&"
import script from "./wax-usage-table.vue?vue&type=script&lang=js&"
export * from "./wax-usage-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports